import { useEffect } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { useReload } from "../../presentations/context/AppReloadContext";
import Assets from "../../applications/assets";
import usePageState from "../../presentations/hooks/usePageState";

const BASE_URL = process.env.REACT_APP_BASE_URL;


function AdminSocketNewOrder() {
  const { showInfo } = usePageState();
  const { setReloadTrigger } = useReload();

  useEffect(() => {
    const client = new Client({
      webSocketFactory: () =>
        BASE_URL ? new SockJS(`${BASE_URL}/api/websocket-order`) : new SockJS("/api/websocket-order"),
      onConnect: () => {
        console.log("Connected to WebSocket");

        // Đăng ký nhận đơn hàng mới
        client.subscribe("/admin-notify/new-order", (message) => {
          setReloadTrigger(true);
          showInfo("Khách đặt đơn hàng");
          const ting = new Audio(Assets.TING_TING);
          const newOrderText = new Audio(Assets.NEW_ORDER_TEXT);
          ting.play();
          setTimeout(() => {
           newOrderText.play();
          }, 800);
        });
      },
      onStompError: (frame) => {
        console.error("Broker error", frame.headers["message"]);
      },
    });

    client.activate();

    return () => {
      client.deactivate();
    };
  }, []);

  // return <div>📦 Admin đang lắng nghe đơn hàng mới...</div>;
  return <></>;
}

export default AdminSocketNewOrder;
